<script>
    import R, {LOADER} from "../lib/requests";
    import app from '../stores/app';
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import NumberSpinner from "../components/controls/NumberSpinner.svelte";

    let settings = null;


    const load = () => {
        const onSuccess = result => {
            settings = result;
        }

        const onFailure = err => {
        };

        R.handle(R.settings.index, {}, onSuccess, onFailure, LOADER.PAGE);
    }

    const save = () => {
        const onSuccess = result => {
            settings = result;
            app.setSettings(settings);
            Notifier.showMessage("Settings updated");
        }

        const onFailure = err => {
        };

        R.handle(R.settings.edit, settings, onSuccess, onFailure, LOADER.POPUP);
    }


    load();
</script>

<PageHeader title="Settings"/>

{#if settings}
    <div class="row">
        <div class="col-xl-3 col-lg-5 col-md-6">
            <div class="panel-simple panel-pad">
                <div class="form-group">
                    <label>Max cruise persons</label>
                    <NumberSpinner bind:value={settings.max_cruise_persons}/>
                </div>
                <div class="form-group">
                    <label>Reservations email</label>
                    <input type="email" class="form-control" bind:value="{ settings.reservations_email }">
                </div>
                <hr>
                <div class="text-end">
                    <button class="btn btn-primary px-4" on:click={save}>SAVE</button>
                </div>
            </div>
        </div>
    </div>
{/if}